export default {
	items: [],
	selectedItem: {},
	menus: [],
	remove_result: [],
	cash_symbols: [],
	stock_symbols: [],
}